
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import { Media, MediaInputValue } from "@/types/media";
import TogglePanel from "../../components/TogglePanel.vue";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import MediaUploadDialog from "@/components/Reusable/CustomInputs/MediaInput/MediaUploadDialog.vue";
import { rerenderElementsThatUseLogo } from "@/futurelayer/brand/logo";
import { saveBrandSettings } from "@/lib/singularity/brand/settings";
import { SingularityBrand } from "@/types/singularity/brand";
import SingularityEmptyState from "../../components/SingularityEmptyState.vue";
import { logEvent } from "@/util/tracking";

@Component({
  components: {
    TogglePanel,
    Icon,
    NiceButton,
    MediaUploadDialog,
    SingularityEmptyState
  }
})
export default class BrandManageLogo extends Vue {
  dialogOpen = false;

  get isPanelOpen() {
    return singularityStore.brandPanelState?.openedPanel === "logo";
  }

  get brand() {
    return singularityStore.brand;
  }

  get currentLogo(): Media | null {
    return this.brand.logo?.logo || null;
  }

  openMediaPicker() {
    this.dialogOpen = true;
  }

  closeDialog() {
    this.dialogOpen = false;
  }

  onMediaSelected(media: MediaInputValue) {
    if (media && !Array.isArray(media)) {
      this.updateLogo(media);
    }
    this.closeDialog();
  }

  async updateLogo(media: Media) {
    const updatedBrand = {
      ...this.brand,
      logo: {
        logo: media
      }
    };
    logEvent("FutureLayer Brand: Logo Updated");
    await this.setBrandAndRerender(updatedBrand);
  }

  async removeLogo() {
    const updatedBrand = {
      ...this.brand,
      logo: {
        logo: null
      }
    };
    logEvent("FutureLayer Brand: Logo Removed");
    await this.setBrandAndRerender(updatedBrand);
  }

  loading = false;
  async setBrandAndRerender(updatedBrand: SingularityBrand) {
    this.loading = true;
    singularityStore.setBrand(updatedBrand);
    await saveBrandSettings();
    await rerenderElementsThatUseLogo();
    this.loading = false;
  }

  get previewStyles() {
    if (!this.brand.color.neutral) {
      return {};
    }
    return {
      backgroundColor: this.brand.color.primary?.scale[100].value?.toString()
    };
  }
}
